// extracted by mini-css-extract-plugin
export default {"main":"Overflow_main__yAx9X"};